import { useState, useEffect } from "react";
import { FetchUserApi } from "../services/MensionService";

export const useMenstionUserLst = (search) => {
  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        setIsLoading(true);
        const response = await FetchUserApi(`&search=${search}`);
        setUser(response?.get_mention_people || []); // update with correct response format
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserList(); // Call the function when component mounts or search changes
  }, [search]);

  return {
    isLoading,
    user,
  };
};
